<template>
  <div class="btn-toolbar">
    <b-button-group>
      <b-button
        v-if="!this.saving()"
        class="txt-btn"
        variant="primary"
        @click.prevent="saveFicheChanges"
      >
        <font-awesome-icon :icon="['fas', 'save']" /> Enregister
      </b-button>
      <b-button v-else class="txt-btn" variant="primary">
        <b-spinner small type="grow"></b-spinner> En attente...
      </b-button>
    </b-button-group>
    <template v-if="!this.isProjectTemplate()">
      <b-button-group>
        <b-button
          class="txt-btn"
          variant="outline-primary"
          @click="openSelectionModal"
        >
          <font-awesome-icon :icon="['fas', 'download']" /> Importer
        </b-button>
      </b-button-group>
      <b-button-group>
        <b-button
          class="txt-btn"
          variant="outline-primary"
          @click="openSelectionFicheModal"
        >
          <font-awesome-icon :icon="['fas', 'copy']" /> Dupliquer
        </b-button>
      </b-button-group>
    </template>
    <div class="divider"></div>
    <b-button-group>
      <b-button
        class="txt-btn"
        variant="outline-warning"
        @click.prevent="exitEditMode"
      >
        Sortir du mode édition
      </b-button>
    </b-button-group>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  methods: {
    ...mapActions(['saveFicheEspace', 'updateFicheTemplate', 'loadTemplatesFiche', 'overwriteDroppedHeader', 'overwriteDeletedHeader', 'setSaving']),
    ...mapGetters(['currentFicheData', 'isGeneratingFiche', 'isProjectTemplate', 'templatesFiche', 'droppedHeaders', 'saving', 'currentProject']),
    saveFicheChanges () {
      this.$emit('saveChanges')
    },
    async openSelectionModal () {
      this.$emit('openSelectionTemplate')
      if (Object.keys(this.templatesFiche()).length === 0) {
        await this.loadTemplatesFiche()
      }
    },
    openSelectionFicheModal () {
      this.$emit('openSelectionFicheModal')
    },
    exitEditMode () {
      this.$emit('exitEditMode')
    }
  }
}
</script>

<style lang="scss" scoped>
.divider {
  border-right: 1px solid #d1e1ef;
  width: 2px;
  margin: 0 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/ficheEspace/edit/toolbar.vue